import { FormPanel } from '@checkit/react-components';
import { Button, FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';
import React, { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';
import { appMessages } from '../../../../translations';
import { messages } from '../CheckpointForm.translations';
import { TextInput } from './TextInput';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%'
  }
}));

interface Props {
  className?: string;
  initialValue?: string;
}

export const IdentitySection: FC<Props> = ({ className, initialValue }: Props) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState<boolean>(!!initialValue);

  const classes = useStyles();

  const {control, watch} = useFormContext();
  const {setValue} = control;
  const setGeneratedIdentity = (value: string) => setValue('qrCodeId', value, {shouldDirty: true});

  const identityValue = watch('qrCodeId', initialValue);

  function handleGenerate() {
    setGeneratedIdentity(uuid());
  }

  function handleRadioChange(_: any, value: string) {
    if (value === 'true') {
      setOpen(true);
    } else {
      setOpen(false);
      setGeneratedIdentity('');
    }
  }

  const subheading = identityValue === '' ? 'app.disabled' : 'app.enabled';

  return (
    <FormPanel
      heading={formatMessage(messages['checkpoint.form.proofOfPresence'])}
      secondaryHeading={formatMessage(appMessages[subheading])}
      name="proof-of-presence"
      initialExpanded={false}
    >
      <RadioGroup
        className={clsx(className, classes.fullWidth)}
        aria-label="create-identity"
        name="create-identity"
        onChange={handleRadioChange}
        value={String(open)}
      >
        <FormControlLabel
          value={'false'}
          control={<Radio />}
          label={formatMessage(messages['checkpoint.form.noProofOfPresence'])}
        />
        <FormControlLabel
          value={'true'}
          control={<Radio />}
          label={formatMessage(messages['checkpoint.form.createIdentity'])}
        />
      </RadioGroup>
      <Collapse in={open}>
        <Button
          className={className}
          variant="outlined"
          color="primary"
          size="small"
          onClick={handleGenerate}
        >
          {formatMessage(messages['checkpoint.form.generateIdentity'])}
        </Button>
        <TextInput
          name="qrCodeId"
          label={formatMessage(messages['checkpoint.form.identity'])}
          initialValue={initialValue || ''}
        />
      </Collapse>
    </FormPanel>
  );
};
